export default "\r\n\r\n\r\n\r\n<!--<a id=\"closeModal\" hidden role=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\"></a>-->\r\n"